module.exports = __webpack_public_path__ + "img/outline_bg_wap_2023_01_19.16f89fb4.png";